export const Badge = ({ variant = 'primary', size = 'md', children, className = '', icon }) => {
    const variants = {
        primary: 'bg-blue-100 text-blue-800 border-blue-200',
        success: 'bg-green-100 text-green-800 border-green-200',
        warning: 'bg-yellow-100 text-yellow-800 border-yellow-200',
        danger: 'bg-red-100 text-red-800 border-red-200',
        gray: 'bg-gray-100 text-gray-800 border-gray-200',
        purple: 'bg-purple-100 text-purple-800 border-purple-200',
        indigo: 'bg-indigo-100 text-indigo-800 border-indigo-200'
    };

    const sizes = {
        sm: 'px-2 py-0.5 text-xs',
        md: 'px-2.5 py-1 text-xs',
        lg: 'px-3 py-1.5 text-sm'
    };

    const IconComponent = icon;

    return (
        <span className={`
      inline-flex items-center rounded-full font-medium border
      ${variants[variant]} 
      ${sizes[size]} 
      ${className}
    `}>
            {icon && <IconComponent className="w-3 h-3 mr-1" />}
            {children}
        </span>
    );
};

export default Badge;